<template>
    <v-list-subheader color="lightText" class="smallCap text-subtitle-2">{{ item.header }}</v-list-subheader>
  </template>
  
  <script>
  export default {
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
  };
  </script>
  